import { LoadingSpinner } from '@/components/ui';
import React, { memo, Suspense } from 'react';

interface OptimizedContentProps {
  children: React.ReactNode;
  className?: string;
}

// Componente de contenido optimizado con Suspense
const OptimizedContent = memo<OptimizedContentProps>(
  ({ children, className }) => {
    return (
      <main className={className}>
        <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
      </main>
    );
  }
);

OptimizedContent.displayName = 'OptimizedContent';

export default OptimizedContent;
